import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'
import { isRtl } from 'src/helper/tool'

import lang from '../lang'

export default class extends React.Component {
  state = {
    ruleStatus: false
  }

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  // shouldComponentUpdate(nextProps) {
  //   console.log('shouldComponentUpdate')
  //   // return false
  // }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  hideRule = async (status) => {
    this.setState({
      ruleStatus: status
    })
  }

  render() {
    let { language, list, lang } = this.props
    return (
      <div>
        {this.state.ruleStatus && <div className="loading" onClick={this.hideRule.bind(this, false)}></div>}
        {this.state.ruleStatus && (
          <div className={`popRule3 ${isRtl(language) && 'arlang'}`} onClick={this.hideRule.bind(this, false)}>
            <div className="ptop">{lang.ruleTitle}</div>
            <div className="content">
              <div className="text">
                <div className="ye" dangerouslySetInnerHTML={{ __html: lang.register || '' }}></div>
                <div dangerouslySetInnerHTML={{ __html: lang.registerTxt || '' }}></div>
                <div className="ye" dangerouslySetInnerHTML={{ __html: lang.SupportRewards || '' }}></div>
                <div dangerouslySetInnerHTML={{ __html: lang.rulePop || '' }}></div>
                <div className="ye" dangerouslySetInnerHTML={{ __html: lang.HonorRewards || '' }}></div>
                <div dangerouslySetInnerHTML={{ __html: lang.HonorRewardsTxt || '' }}></div>
                <div dangerouslySetInnerHTML={{ __html: lang.HonorRewardsTxt2 || '' }}></div>
              </div>
            </div>
            <div className="pbottom"></div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport/Rule/index.js